import { GroupResourceWithBulletinMembership } from "@rubi/api-generated";

import { IAlertGroup } from "@/types/typesAlerts";

export type BulletinAccessState = {
  bulletinId: number;
  sharedGroups: GroupResourceWithBulletinMembership[];
}[];

export type BulletinAccessAction =
  | {
      type: "SET_BULLETINS_AND_ITS_GROUPS";
      payload: {
        bulletinId: number;
        groups: GroupResourceWithBulletinMembership[];
      };
    }
  | {
      type: "ADD_GROUP_TO_ALL_BULLETINS";
      payload: {
        group: GroupResourceWithBulletinMembership;
      };
    }
  | {
      type: "REMOVE_GROUP_FROM_BULLETINS";
      payload: {
        groupId: number;
      };
    };

export type potentialGroupsState = {
  userBelongedGroups: IAlertGroup[];
  otherGroups: IAlertGroup[];
  publicGroup: IAlertGroup | null;
};

export type NotifyState = {
  notifiedGroups: IAlertGroup[];
  includeMyself: boolean;
  individualEmails: string[];
};

export type NotifyAction =
  | { type: "TOGGLE_GROUP_NOTIFY"; group: IAlertGroup }
  | { type: "SET_INCLUDE_MYSELF" }
  | { type: "ADD_INDIVIDUAL_EMAIL"; email: string }
  | { type: "REMOVE_INDIVIDUAL_EMAIL"; email: string }
  | { type: "SET_INDIVIDUAL_EMAILS"; emails: string[] }
  | { type: "RESET" };

export enum PortalAccessCheckboxStatus {
  CHECKED = "checked",
  INDETERMINATE = "indeterminate",
  UNCHECKED = "unchecked",
}

export function getGroupStatusByBulletinId(
  state: BulletinAccessState,
  groupId: number,
): PortalAccessCheckboxStatus {
  const groupInAllBulletins = state.every((bulletin) =>
    bulletin.sharedGroups.some((group) => group.id === groupId),
  );

  const bulletinsWithGroup = state
    .map((bulletin) =>
      bulletin.sharedGroups.find((group) => group.id === groupId),
    )
    .filter((group): group is GroupResourceWithBulletinMembership => !!group);

  if (bulletinsWithGroup.length === 0) {
    return PortalAccessCheckboxStatus.UNCHECKED;
  }

  if (!groupInAllBulletins) {
    return PortalAccessCheckboxStatus.INDETERMINATE;
  }

  const firstExpire = bulletinsWithGroup[0].time_expires;
  const allExpireSame = bulletinsWithGroup.every(
    (group) => group.time_expires === firstExpire,
  );

  return allExpireSame
    ? PortalAccessCheckboxStatus.CHECKED
    : PortalAccessCheckboxStatus.INDETERMINATE;
}
